import React from 'react';
import { AppRoutes } from './routes/routes';
import { useGoogleApi } from './hooks/useGoogleApi';

export const AppModule: React.FC = () => {
  useGoogleApi();

  return <AppRoutes />;
};
